import styled from 'styled-components';

import { Title } from '@xsolla/ui-core';
import { CogDouble } from '@xsolla/ui-icons';

import { SpaceBetweenBlock } from '../../../styled';
import { LinkStyles } from '../../ui';

export const LauncherWrapper = styled.div`
  margin: 0 -82px;
  width: 468px;
`;

export const LaunchersTitle = styled(Title)`
  margin-top: 16px;
`;

export const LaunchersDescription = styled.p`
  ${(p) => p.theme.typography.description};
  margin-top: 16px;
  margin-bottom: 32px;
`;

export const LauncherLinksWrapper = styled(SpaceBetweenBlock)`
  flex-direction: column;
  gap: 16px;
`;

export const StyledLink = styled(LinkStyles)`
  margin-top: 16px;
  display: flex;
  align-items: center;
`;

export const StyledCog = styled(CogDouble)`
  vertical-align: middle;
`;
